import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";

interface RelatedListProps {
  movies: Movie[];
}

export default function RelatedList({ movies }: RelatedListProps) {
  return (
    <div className="rounded-lg border border-background-200/70 bg-background-50 p-4">
      <h2 className="mb-4 font-heading text-base font-bold text-foreground-950">相关推荐</h2>
      <ul className="flex flex-col gap-3">
        {movies.map((movie) => (
          <li key={movie.id}>
            <Link
              to={`/detail/${movie.id}`}
              className="group flex gap-3 rounded-md p-2 transition-colors hover:bg-background-100"
            >
              <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={movie.cover}
                  alt={`${movie.title} 海报`}
                  title={`${movie.title} 伦理影视`}
                  className="h-full w-full object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
                  {movie.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">
                  {movie.year} · {movie.type === "movie" ? "电影" : `${movie.episodes}集`}
                </p>
                <p className="mt-1 flex items-center gap-1 text-xs font-medium text-accent-600">
                  <i className="ri-star-fill"></i> {movie.rating.toFixed(1)}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}